import Modal from "../../CommonComponents/common/modal/Modal";
import { Box, CircularProgress, Typography, Divider } from "@mui/material";

const LabelValue = ({ label, value }) => (
    <Box sx={{ display: "flex", mb: 1 }}>
        <Typography sx={{ fontWeight: 600, fontSize: 14, minWidth: 180 }}>
            {label}:
        </Typography>
        <Typography>{value}</Typography>
    </Box>
);

const TicketDetailsModal = ({ open, handleClose, loading, ticket }) => {
    if (!ticket && !loading) return null;
    return (
        <Modal
            open={open}
            handleClose={handleClose}
            title="Ticket Details"
            initialWidth={900}
            initialHeight={600}
            content={
                loading ? (
                    <Box sx={{ display: "flex", justifyContent: "center", height: "100%" }}>
                        <CircularProgress size={40} sx={{ color: "#7d7c7cff" }} />
                    </Box>
                ) : (
                    <Box sx={{ p: 2, mt: 1.5 }}>
                        <LabelValue label="Ticket Number" value={ticket.ticketNumber} />
                        <LabelValue label="Menu" value={ticket.menu} />
                        <LabelValue label="Sub Menu" value={ticket.subMenu} />
                        <LabelValue label="Category" value={ticket.category} />

                        <Divider sx={{ my: 2 }} />

                        <LabelValue label="Description" value={ticket.description} />
                        <Divider sx={{ my: 2 }} />

                        <LabelValue label="Status" value={ticket.status} />
                        <LabelValue label="Priority" value={ticket.priority} />
                    </Box>
                )
            }
            action={
                <Box display="flex" justifyContent="flex-end" width="100%">
                    <button className="btn btn-primary" onClick={handleClose}>
                        Close
                    </button>
                </Box>
            }
        />
    );
};

export default TicketDetailsModal;